import { candidateTimingNote } from '../../lib/candleTime';
import { formatDuration, formatTime } from '../../lib/format';
import type { CandleTiming, ChartInterval } from '../../types/market';
import { Badge } from '../ui/Badge';
import { Panel } from '../ui/Panel';

export function CandleTimePanel({ interval, timing }: { interval: ChartInterval; timing: CandleTiming }): React.JSX.Element {
  return (
    <Panel
      title="Candle-time intelligence"
      description="Real exchange-aligned time changes how the active candle is interpreted."
      action={<Badge tone={timing.freshIssuanceAllowed ? 'info' : 'warning'}>{timing.phase}</Badge>}
    >
      <dl className="info-list">
        <div className="info-row"><dt>Selected interval</dt><dd>{interval.toUpperCase()}</dd></div>
        <div className="info-row"><dt>Candle opened</dt><dd>{formatTime(timing.openTime)}</dd></div>
        <div className="info-row"><dt>Candle closes</dt><dd>{formatTime(timing.closeTime)}</dd></div>
        <div className="info-row"><dt>Maturity</dt><dd>{timing.maturity.toFixed(1)}%</dd></div>
        <div className="info-row"><dt>Time remaining</dt><dd>{formatDuration(timing.remainingMs)}</dd></div>
        <div className="info-row"><dt>Fresh same-horizon issuance</dt><dd>{timing.freshIssuanceAllowed ? 'Allowed with context' : 'Blocked near transition'}</dd></div>
      </dl>
      <div className="attribution-list"><div className="notice">{candidateTimingNote(timing)}</div></div>
    </Panel>
  );
}
